import { Loading } from "@/components/atoms";
import { useClientScope } from "@/components/pages/Client/settings/ClientScopeContext";
import { useGetAdminSettingsQuery } from "@/redux/apis/clientAdminSettings/clientAdminSettingsApi";
import { useGetClientProfileQuery } from "@/redux/apis/clientProfile/clientProfileApi";
import { YourDetails } from "./YourDetails";
import { YourDetailsMobile } from "./YourDetailsMobile";

export const YourDetailsSection = ({ readOnly = false }: { readOnly?: boolean }) => {
  // Operator-managed client when set; undefined in self-service.
  const { accountId } = useClientScope();
  const { data: profile, isLoading } = useGetClientProfileQuery(accountId ? { accountId } : undefined);
  const { data: adminSettings } = useGetAdminSettingsQuery({ accountId }, { skip: !accountId });

  if (isLoading) return <Loading />;
  if (!profile) return null;

  // Operator edits land on the managed client's Settings→Profile tab (relative);
  // self-service keeps the absolute client route.
  const editTo = accountId ? "../settings/profile" : "/client/settings/profile";

  return (
    <>
      {/* Desktop/Tablet — operator view supplies its own "Client Details" header, so suppress the card heading. */}
      <div className="hidden md:block">
        <YourDetails
          profile={profile}
          editTo={editTo}
          heading={accountId ? null : undefined}
          readOnly={readOnly}
          isVip={adminSettings?.vip_status}
        />
      </div>
      {/* Mobile (no inline edit affordance — parity with current client mobile view) */}
      <div className="md:hidden">
        <YourDetailsMobile profile={profile} />
      </div>
    </>
  );
};
